import Image from "next/image";
import { quoteSvg } from "../svg";

const Testimony = () => {
  return (
    <div className="container">
      <div className="row pt-2 ">
        <h2 className="text-center col-sm-12">Expert Basketball Handicappers Love ShotQuality</h2>
      </div>
      <div className="row d-flex justify-content-evenly  mt-2">
        <div className=" col-sm-12 col-md-3  p-3 m-3" style={{ background: "#f3f4f6", borderRadius: "20px" }}>
          <div className=" d-flex justify-content-between">
            <div className="d-flex mb-3">
              {/* Url returns 404 */}
              <Image
                style={{ mixBlendMode: "multiply" }}
                // src="https://pbs.twimg.com/profile_images/1577488904839733248/KhXYFYzc_400x400.jpg"
                src="https://pbs.twimg.com/profile_images/1427790197455007744/rh5vkXid_400x400.jpg"
                width={36}
                height={36}
                loading="lazy"
                alt="Mike McClure, Sportsline"
              />
              <div className="d-flex flex-column">
                <h3>Mike McClure, Sportsline</h3>
                <a className="twitterLink" href="https://twitter.com/mike5754">
                  @Mike5754
                </a>
              </div>
            </div>
            {quoteSvg}
          </div>
          <p className="text-black">
            ShotQuality’s predictive basketball data is some of the best in sports. Without ShotQuality live betting is
            alot like flipping a coin.
          </p>
        </div>
        <div className="col-md-1"></div>

        <div className=" col-sm-12 col-md-3  p-3 m-3" style={{ background: "#f3f4f6", borderRadius: "20px" }}>
          <div className="d-flex justify-content-between">
            <div className="d-flex mb-3">
              <Image
                style={{ mixBlendMode: "multiply" }}
                src="https://pbs.twimg.com/profile_images/1427790197455007744/rh5vkXid_400x400.jpg"
                width={36}
                height={36}
                loading="lazy"
                alt="Jordan Majewski, Sports Writer"
              />
              <div className="d-flex flex-column">
                <h3>Jordan Majewski, Sports Writer</h3>
                <a className="twitterLink" href="https://twitter.com/jorcubsdan">
                  @jorcubsdan
                </a>
              </div>
            </div>
            {quoteSvg}
          </div>
          <p className="text-black">
            ShotQuality delivers the most useful advanced metrics and analysis in basketball.
          </p>
        </div>
        <div className="col-md-1"></div>

        <div className=" col-sm-12 col-md-3  p-3 m-3" style={{ background: "#f3f4f6", borderRadius: "20px" }}>
          <div className="d-flex justify-content-between">
            <div className="d-flex mb-3">
              <Image
                style={{ mixBlendMode: "multiply" }}
                src="https://pbs.twimg.com/profile_images/1502469232226971655/JJMuAY4N_400x400.jpg"
                width={36}
                height={36}
                loading="lazy"
                alt="Barstool Big Cat"
              />
              <div className="d-flex flex-column">
                <h3> Barstool Big Cat</h3>
                <a className="twitterLink" href="https://twitter.com/barstoolbigcat">
                  @BarstoolBigCat
                </a>
              </div>
            </div>
            {quoteSvg}
          </div>
          <p className="text-black">
            ShotQuality analysis highlights value on the board all season long, and you know I love the board.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Testimony;
